module.exports = __webpack_public_path__ + "static/media/search.a311df72.svg";